import React__default, { useContext, createContext } from 'react';

const TileControlContext = /*#__PURE__*/createContext({
  focusProps: undefined,
  label: '',
  onChange: undefined,
  value: undefined,
  innerRef: undefined,
  restProps: {}
});
const useTileControlContext = () => useContext(TileControlContext);
const TileControlContextProvider = ({
  focusProps,
  label,
  onChange,
  value,
  innerRef,
  restProps,
  children
}) => /*#__PURE__*/React__default.createElement(TileControlContext.Provider, {
  value: {
    focusProps,
    label,
    onChange,
    value,
    innerRef,
    restProps
  }
}, children);
const DEFAULT_TILE_CONTEXT = {
  direction: 'column',
  disabled: false,
  selected: false
};
const TileContext = /*#__PURE__*/createContext(DEFAULT_TILE_CONTEXT);
const TileContextProvider = ({
  direction,
  disabled,
  selected,
  children
}) => /*#__PURE__*/React__default.createElement(TileContext.Provider, {
  value: {
    direction,
    disabled,
    selected
  }
}, children);
const useTileContext = () => {
  const {
    direction,
    disabled,
    selected
  } = useContext(TileContext);
  return {
    direction,
    disabled,
    selected
  };
};

export { DEFAULT_TILE_CONTEXT as D, TileContextProvider as T, TileControlContextProvider as a, useTileControlContext as b, useTileContext as u };
//# sourceMappingURL=TileContext-CI56_oXw.js.map
